import { CHAIN_ID, TRIPTCIP_CONTRACT_ADDRESS, URL } from '../config'

export const getLinkEntity = ({
  creatorUsername,
  slug
}) => {
  return `/${creatorUsername}/${slug}`
}

export const getLinkProfile = ({
  username
}) => {
  return `/${username}`
}

export const getLinkBid = ({
  creatorUsername,
  slug
}) => {
  const entityLink = getLinkEntity({
    creatorUsername,
    slug
  })

  return `${entityLink}/bid`
}

export const getLinkClaim = ({
  creatorUsername,
  slug
}) => {
  const entityLink = getLinkEntity({
    creatorUsername,
    slug
  })

  return `${entityLink}/claim`
}

export const getLinkCreateOffer = ({
  creatorUsername,
  slug
}) => {
  const entityLink = getLinkEntity({
    creatorUsername,
    slug
  })

  return `${entityLink}/offer`
}

export const getSceneLink = (scene) => {
  return `${URL}/projects/create/scene/${scene.presetName}`
}

export const getProjectLink = projectId => {
  return `${URL}/projects/${projectId}`
}

export const getEtherscanLinkTx = txHash => {
  if (CHAIN_ID === 4) {
    return `https://rinkeby.etherscan.io/tx/${txHash}`
  }

  return `https://etherscan.io/tx/${txHash}`
}

export const getEtherscanTokenLink = tokenId => {
  if (CHAIN_ID === 4) {
    return `https://rinkeby.etherscan.io/token/${TRIPTCIP_CONTRACT_ADDRESS}?a=${tokenId}`
  }

  return `https://etherscan.io/token/${TRIPTCIP_CONTRACT_ADDRESS}?a=${tokenId}`
}
